/* Sofrea Reset product page v3: tabs, sticky add-to-cart bar, CTA scroll.
   The sticky bar never adds to cart itself: it clicks the main Add to cart
   button, so Kaching Bundles / Subscriptions keep handling the order. */
(function () {
  // Tabs (What is Sofrea, Three systems)
  document.querySelectorAll('[data-sf-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  });

  function mainButton() {
    return document.querySelector('#buy-now .product-form__add-button, #buy-now button[name="add"], .product--featured .product-form__add-button');
  }

  function scrollToBuy(e) {
    var box = document.querySelector('.kaching-bundles') || document.getElementById('buy-now');
    if (!box) return;
    if (e) e.preventDefault();
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.querySelectorAll('[data-sf-scroll-buy]').forEach(function (a) { a.addEventListener('click', scrollToBuy); });

  // Plan cards: show subscription prices per month and per day, like the mockup.
  // Figures are derived from the prices Kaching renders, so they always match the real charge.
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, ''); }
  function num(el) { return el ? parseFloat(el.textContent.replace(/[^0-9.,]/g, '').replace(',', '.')) : NaN; }
  var dealCfg = null;
  try { dealCfg = JSON.parse((document.querySelector('script.kaching-bundles-deal-block-settings') || {}).textContent || 'null'); } catch (e) {}
  function decoratePlans() {
    if (!dealCfg || !dealCfg.dealBars) return;
    var bars = document.querySelectorAll('.kaching-bundles__bars > .kaching-bundles__bar');
    bars.forEach(function (bar, i) {
      var cfg = dealCfg.dealBars[i];
      if (cfg && !cfg.sellingPlanEnabled) { if (!bar.classList.contains('sf-konce')) bar.classList.add('sf-konce'); buyOnceLink(bar); return; }
      if (!cfg) return;
      var q = cfg.quantity || 1;
      var price = num(bar.querySelector('.kaching-bundles__bar-price'));
      var full = num(bar.querySelector('.kaching-bundles__bar-full-price'));
      if (isNaN(price)) return;
      var key = [q, price, full].join('|');
      if (bar.getAttribute('data-sf-k') === key && bar.querySelector('.sf-kprice')) return;
      bar.setAttribute('data-sf-k', key);
      if (!bar.classList.contains('sf-kplan')) bar.classList.add('sf-kplan');
      var left = bar.querySelector('.kaching-bundles__bar-content-left');
      var pricing = bar.querySelector('.kaching-bundles__bar-pricing');
      if (!left || !pricing) return;
      var old = bar.querySelectorAll('.sf-kbilled, .sf-kprice');
      old.forEach(function (n) { n.remove(); });
      var billed = document.createElement('span');
      billed.className = 'sf-kbilled';
      billed.textContent = money(price) + ' billed every ' + (q > 1 ? q + ' months' : 'month');
      left.appendChild(billed);
      var box = document.createElement('div');
      box.className = 'sf-kprice';
      box.innerHTML = '<span class="sf-kprice__main"></span>' + (isNaN(full) ? '' : '<span class="sf-kprice__was"></span>') + '<span class="sf-kprice__day"></span>';
      box.querySelector('.sf-kprice__main').textContent = money(price / q) + '/mo';
      if (!isNaN(full)) box.querySelector('.sf-kprice__was').textContent = money(full / q) + '/mo';
      box.querySelector('.sf-kprice__day').textContent = money(price / (q * 30)) + '/day';
      pricing.appendChild(box);
    });
  }
  // One-time purchase: shown as a small link above Add to cart.
  // The link selects Kaching's own one-time bar, so the cart logic stays Kaching's.
  function buyOnceLink(bar) {
    var atc = mainButton();
    if (!atc) return;
    var link = document.querySelector('.sf-buyonce');
    if (!link) {
      link = document.createElement('a');
      link.href = '#';
      link.className = 'sf-buyonce';
      atc.insertAdjacentElement('beforebegin', link);
    }
    var price = bar.querySelector('.kaching-bundles__bar-price');
    var sub = bar.querySelector('.kaching-bundles__bar-second-line');
    var txt = 'Buy once for ' + (price ? price.textContent.trim().replace(/\.00$/, '') : '') + (sub && sub.textContent.trim() ? ' ' + sub.textContent.trim() : '');
    if (link.textContent !== txt) link.textContent = txt;
    if (link.getAttribute('data-sf-bound')) return;
    link.setAttribute('data-sf-bound', '1');
    link.onclick = function (e) {
      e.preventDefault();
      var once = document.querySelector('.kaching-bundles__bar.sf-konce') || bar;
      var label = once.querySelector('.kaching-bundles__bar-container');
      if (label) label.click();
      setTimeout(function () {
        var sel = document.querySelector('.kaching-bundles__bar.sf-konce') || once;
        sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 350);
    };
  }
  decoratePlans();
  new MutationObserver(function () { decoratePlans(); }).observe(document.body, { subtree: true, childList: true });

  // Sticky bar (product page only, not on the homepage)
  if (document.body.classList.contains('sf-home')) return;
  var btn = mainButton();
  if (!btn) return;
  var bar = document.createElement('div');
  bar.className = 'sf-sticky';
  bar.innerHTML = '<div class="sf-sticky__info"><div class="sf-sticky__name"></div><div class="sf-sticky__plan"></div></div>' +
    '<button type="button" class="sf-sticky__btn">Add to cart</button>';
  document.body.appendChild(bar);
  bar.querySelector('.sf-sticky__name').textContent = (document.querySelector('.product-meta__title') || {}).textContent || '';

  function refreshPlan() {
    var sel = document.querySelector('.kaching-bundles__bar--selected');
    var title = sel && sel.querySelector('.kaching-bundles__bar-title');
    var price = sel && sel.querySelector('.kaching-bundles__bar-price');
    var planText = [title && title.textContent.trim(), price && price.textContent.trim()].filter(Boolean).join(' · ');
    var planEl = bar.querySelector('.sf-sticky__plan');
    if (planEl.textContent !== planText) planEl.textContent = planText;
  }
  refreshPlan();
  new MutationObserver(refreshPlan).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class'] });

  bar.querySelector('.sf-sticky__btn').addEventListener('click', function () {
    var b = mainButton();
    if (b) b.click();
  });

  // Mobile: the buy bar is always visible (as in the mockup)
  var mobileMq = window.matchMedia('(max-width: 999px)');
  if (mobileMq.matches) { bar.classList.add('is-visible'); document.body.classList.add('sf-has-sticky'); }
  else if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      // Show only once the main button has scrolled above the viewport
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(btn);
  }
  // Theme preview only: lift the bar above Shopify's preview bar so it can be checked
  function liftAbovePreviewBar() {
    var pb = document.getElementById('PBarNextFrame');
    // Shopify's preview frame covers the viewport; its visible bar is ~64px tall at the bottom
    bar.style.bottom = (pb && getComputedStyle(pb).display !== 'none') ? '64px' : '0px';
  }
  liftAbovePreviewBar(); setTimeout(liftAbovePreviewBar, 1500); setTimeout(liftAbovePreviewBar, 4000);
})();

/* Avatar pages: featured reviews. If Judge.me shows reviews, the featured ones are
   pinned first via CSS order and our fallback row is hidden; if Judge.me is empty,
   our row stays and the empty Judge.me widget is hidden. */
(function () {
  var fr = document.querySelector('[data-sf-freviews]');
  if (!fr) return;
  var tries = 0;
  var t = setInterval(function () {
    tries++;
    var items = document.querySelectorAll('.jdgm-review-list .jm-review-item');
    var widget = document.querySelector('.jm-review-widget');
    if (items.length) {
      fr.classList.add('sf-hide');
      if (widget) widget.closest('.shopify-section').style.display = '';
      clearInterval(t);
    } else if (widget && tries > 12) {
      widget.closest('.shopify-section').style.display = 'none';
      clearInterval(t);
    } else if (tries > 40) { clearInterval(t); }
  }, 500);
})();

/* Review cards: read more + arrows */
(function () {
  document.querySelectorAll('[data-sfr]').forEach(function (sec) {
    var row = sec.querySelector('.sfr__row');
    sec.querySelectorAll('.sfr__more').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.closest('.sfr__card'); c.classList.toggle('is-open');
        b.textContent = c.classList.contains('is-open') ? 'Read less' : 'Read more';
      });
    });
    function step() { var c = row.querySelector('.sfr__card'); return c ? c.getBoundingClientRect().width + 20 : 300; }
    var p = sec.querySelector('.sfr__arrow--prev'), n = sec.querySelector('.sfr__arrow--next');
    if (p) p.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
})();

/* Supplement Facts dialog */
(function () {
  var dlg = document.querySelector('[data-sf-facts-dlg]');
  var open = document.querySelector('[data-sf-facts-open]');
  if (!dlg || !open || !dlg.showModal) return;
  open.addEventListener('click', function () { dlg.showModal(); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-sf-facts-close]')) dlg.close(); });
})();

/* Trust row under the main Add to cart button */
(function () {
  if (!document.body.classList.contains('template-product-reset') || document.body.classList.contains('sf-home')) return;
  var ic = function (d) { return '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#5B1630" stroke-width="1.8" aria-hidden="true">' + d + '</svg>'; };
  var html = '<span>' + ic('<path d="M12 3l8 3v6c0 4.5-3.4 8.2-8 9-4.6-.8-8-4.5-8-9V6l8-3z"/><path d="M9 12l2 2 4-4"/>') + '90-Day Money Back Guarantee</span>' +
             '<span>' + ic('<path d="M2 7h11v9H2zM13 10h4l3 3v3h-7z"/><circle cx="6" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/>') + 'Free Shipping on plans</span>' +
             '<span>' + ic('<circle cx="12" cy="12" r="9"/><path d="M9 9l6 6M15 9l-6 6"/>') + 'Cancel Anytime</span>';
  var tries = 0;
  var t = setInterval(function () {
    tries++;
    var atc = document.querySelector('#main .product-form__add-button, .product-form__add-button');
    if (atc && !document.querySelector('.sf-trust')) {
      var row = document.createElement('div'); row.className = 'sf-trust'; row.innerHTML = html;
      var anchor = atc.closest('.product-form__buy-buttons') || atc;
      anchor.insertAdjacentElement('afterend', row);
    }
    if (document.querySelector('.sf-trust') || tries > 20) clearInterval(t);
  }, 300);
})();
